<template>
  <modal transition="pop-out" name="new-permission-modal" :width="350" :height="250">
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <input v-model="form.name" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Eg: Can Create">
        </div>
        <div class="mb-0">
          <label class="block text-gray-700 text-sm font-bold mb-2">Enable</label>
          <el-switch v-model="form.status"></el-switch>
        </div><br>
        <div class="flex justify-start">
          <el-button @click="submit" type="primary" :loading="adding">Save</el-button>
          <el-button @click="closeDialog" type="text">Cancel</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'NewPermissionForm',
  data() {
    return {
      error: false,
      adding: false,
    };
  },
  computed: {
    form() {
      return this.$store.state.SecurityModule.Permission.new_permission;
    },
  },
  methods: {
    async closeDialog() {
      this.$modal.hide('new-permission-modal');
    },
    async submit() {
      this.errors = this.formValidation(this.form);

      if (this.errors.length === 0) {
        try {
          this.adding = true;

          await this.$store.dispatch('SecurityModule/Permission/newPermission', { permission: this.form });
          this.$modal.hide('new-permission-modal');
          this.$notify.success({
            title: 'Success',
            message: 'Permission successfully added',
          });
          this.form.name = '';
        } catch (e) {
          this.adding = false;
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong',
          });
        }

        this.adding = false;
      }
      this.error = false;
    },
  },
};
</script>

<style scoped>

</style>
